import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "../../../../axios.js";
import { GET_TRANSACTION_HISTORY_LIST, GET_BILLING_HISTORY_PDF } from "../../../../Urls.js";

const initialState = {
    transactionHistoryData: { data: [], loading: false },
};

export const getTransactionHistory = createAsyncThunk(
    "app/get/payement/getTransactionHistory",
    async (payload) => {
        const response = await axios.post(GET_TRANSACTION_HISTORY_LIST, { ...payload });
        return response;
    }
);
export const getBillingHistoryPdf = createAsyncThunk(
    "app/get/payement/downloadBillingHistory",
    async (payload) => {
        const response = await axios.post(GET_BILLING_HISTORY_PDF, { ...payload });
        return response;
    }
);


export const transactionHistorySlice = createSlice({
    name: "transactionHistorySlice/billing",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getTransactionHistory.pending, (state) => {
                state.transactionHistoryData.loading = true;
            })
            .addCase(getTransactionHistory.fulfilled, (state, action) => {
                state.transactionHistoryData.loading = false;
                state.transactionHistoryData.data = action?.payload?.data?.data;
            })
            .addCase(getTransactionHistory.rejected, (state) => {
                state.transactionHistoryData.loading = false;
                state.transactionHistoryData.data =[];
            })
    }
});


export const { } = transactionHistorySlice.actions;

export default transactionHistorySlice.reducer;